var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SingleRideHeader',{attrs:{"presentedText":_vm.t('rideChecklistAccommodations')}}),_c('b-container',{staticClass:"py-5"},[_c('SingleRideChecklist')],1),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }